import axios from 'axios';
import { bundle } from '../../helpers';
import { handleErrors, paramBuilder, headerBuilder } from '../http';

var getProfileEndpoint = function getProfileEndpoint() {
  return "".concat(bundle.apiLocation(), "/me");
}; // Extract the profile from the data and return it.
// If there are any errors clean them up and return them instead.


export var fetchProfile = function fetchProfile() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  // Build URL and fetch the space.
  return axios.get(getProfileEndpoint(), {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      profile: response.data
    };
  })["catch"](handleErrors);
};
export var updateProfile = function updateProfile() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var profile = options.profile;

  if (!profile) {
    throw new Error('updateProfile failed! The option "profile" is required.');
  } // Build URL and fetch the space.


  return axios.put(getProfileEndpoint(), profile, {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      profile: response.data.user
    };
  })["catch"](handleErrors);
};